import { isIOS } from "react-device-detect"
import { TopBar } from "../../widgets"
import { useGetProgramListWeb } from "../explore/model"
import WellnessProgramCard from "./ui/card"

const WellnessProgram = () => {
    const responseQuery = "id title thumbnailImageUrl programPeriod bookingPeriod locationName displayIdx isDisableBooking isOnline"
    const { data: programWebList, isPending } = useGetProgramListWeb(responseQuery)

    return <>
        <TopBar title="브랜드 프로그램" rightIcon={false} position='fixed' thema='dark' />
        <div style={{ paddingInline: 'var(--space20)', paddingBlock: `24px ${isIOS ? 46 : 20}px` }}>
            {programWebList?.map((q, idx, arr) => <WellnessProgramCard key={q.id} programData={q} style={{ marginBottom: idx === arr.length - 1 ? 0 : 20 }} />)}
        </div>
    </>
}


export default WellnessProgram